import { IQuestion } from '../models/question'
import Api, { IApiResponse } from './index'
import { BaseUrl } from './base_url_enum'

type IGetQuestionsResponse = {
  frequentlyAskedQuestions: IQuestion[]
}

export const getQuestions = () => Api<IApiResponse<IGetQuestionsResponse>>('GET', 'frequently-asked-questions', BaseUrl.Content)
